import { withZod } from '@rvf/zod'
import { z } from 'zod'
import { zfd } from 'zod-form-data'

export type ReportPdfOptions = {
  type: string
  preparedFor?: string
  notes?: string
  showTitlePage: boolean | string
  showEcDevContact: boolean | string
  showContents: boolean | string
  showMapPage: boolean | string
  showBrokers: boolean | string
  showImages: boolean | string
}

export const reportPdfValidator = withZod(
  z.object({
    report: z.custom<Report>(),
    _id: z.string(),
    tid: z.string(),
    created: z.string(),
    modified: z.string(),
    status: z.string(),
    // showProfilePage: zfd.checkbox(),
    // showMapPage: zfd.checkbox(),
    options: z.object({
      type: zfd.text(z.string()),
      preparedFor: zfd.text(z.string().optional()),
      notes: zfd.text(z.string().optional()),
      showEcDevContact: zfd.checkbox(),
      showTitlePage: zfd.checkbox(),
      showContents: zfd.checkbox(),
      showMapPage: zfd.checkbox(),
      showBrokers: zfd.checkbox(),
      showImages: zfd.checkbox(),
    }),
  })
)
